module.exports = __webpack_public_path__ + "media/00_らくらく点検とは.51037b7c.mp4";